import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset, getOrgInfo } from '../services/api';
import './Login.css';

// Шапочка повара вместо эмодзи 🍽️ — сервис для ресторанов/общепита.
const ChefHatIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 14.584C3.2341 13.8124 2 12.0503 2 10C2 7.23858 4.23858 5 7 5C7.25052 5 7.49673 5.01842 7.73736 5.05399" />
    <path d="M19 14.584V18C19 19.8856 19 20.8285 18.4142 21.4142C17.8284 22 16.8856 22 15 22H9C7.11438 22 6.17157 22 5.58579 21.4142C5 20.8285 5 19.8856 5 18V14.584" />
    <path d="M16.2627 5.05399C16.5033 5.01842 16.7495 5 17.0001 5C19.7615 5 22.0001 7.23858 22.0001 10C22.0001 12.0503 20.766 13.8124 19.0001 14.584" />
    <path d="M16.5 7V6.5C16.5 5.99416 16.4165 5.50782 16.2626 5.05399C15.6604 3.27806 13.9794 2 12 2C10.0206 2 8.33962 3.27806 7.73736 5.05399C7.58346 5.50782 7.5 5.99416 7.5 6.5V7" />
    <path d="M5 18H19" />
  </svg>
);

const EyeIcon = ({ open }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    {open ? (
      <>
        <path d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z" />
        <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" />
      </>
    ) : (
      <path d="M12 14C5 14 2 7 2 7M22 7C22 7 21.0586 9.19661 19 11.1288C18.0872 11.9856 16.9547 12.7904 15.5872 13.3287C14.5334 13.7435 13.34 14 12 14M12 14V16.5M15.5872 13.3287L17 15.5M19 11.1288L20.5 12.6288M8.41281 13.3287L7 15.5M5 11.1288L3.5 12.6288" />
    )}
  </svg>
);

// Второй шаг восстановления: переход по ссылке из письма. Первый шаг —
// заявка — живёт прямо на экране входа (Login.jsx), отдельной страницы для
// него нет: человек попадает туда ровно тогда, когда не смог войти.
const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [org, setOrg] = useState(null);
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getOrgInfo().then(setOrg).catch(() => setOrg({ found: false }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Сверку паролей делаем на клиенте: гонять пару на сервер только ради
    // сообщения «не совпадают» незачем, а токен при этом сгорит.
    if (password !== repeat) {
      setError('Пароли не совпадают');
      return;
    }
    if (password.length < 6) {
      setError('Пароль должен быть не короче 6 символов');
      return;
    }

    setLoading(true);
    try {
      await confirmPasswordReset(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      if (err.response) {
        setError(err.response.data?.error || 'Не удалось изменить пароль');
      } else {
        setError('Ошибка соединения с сервером');
      }
    } finally {
      setLoading(false);
    }
  };

  if (org === null) {
    return <div className="login-container" />;
  }

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1><span>Ссылка неполная</span></h1>
          <div className="subtitle">
            В адресе нет кода восстановления. Откройте ссылку из письма целиком
            или запросите новую на странице входа.
          </div>
          <button type="button" onClick={() => navigate('/login')}>На страницу входа</button>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1><span>Пароль изменён</span></h1>
          <div className="subtitle">Сейчас откроется страница входа…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>
          <span className="logo-icon"><ChefHatIcon /></span>
          <span>{org.platform ? 'Платформа' : org.name}</span>
        </h1>
        <div className="subtitle">Задайте новый пароль</div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="reset-password">Новый пароль</label>
            <div className="ui-input-wrap">
              <input
                id="reset-password"
                type={visible ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Не короче 6 символов"
                autoComplete="new-password"
                autoFocus
                required
              />
              <button
                type="button"
                className="ui-eye"
                onClick={() => setVisible(v => !v)}
                aria-label={visible ? 'Скрыть пароли' : 'Показать пароли'}
              >
                <EyeIcon open={visible} />
              </button>
            </div>
          </div>
          <div className="input-group">
            <label htmlFor="reset-repeat">Повторите пароль</label>
            <input
              id="reset-repeat"
              type={visible ? 'text' : 'password'}
              value={repeat}
              onChange={(e) => setRepeat(e.target.value)}
              placeholder="Ещё раз"
              autoComplete="new-password"
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Сохраняем...' : 'Сохранить пароль'}
          </button>
          {error && <div className="error" role="alert">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
